import type { SelectedRecipient } from './referral/referralTypes'
import type { CptCode } from './shared/useCptValueSet'

export const PROCEDURE_REFERRAL_QUESTIONNAIRE_ID = 'procedure-referral-requisition'

export const GENERIC_REFERRAL_CPT: CptCode = {
  code: '99242',
  display: 'Office consultation, new patient, straightforward',
}

export interface ProcedureReferralFormState {
  recipient: SelectedRecipient | null
  specialtyCode: string
  specialtyLabel: string
  isEvaluationOnly: boolean
  selectedCptCodes: CptCode[]
  diagnosisText: string
  visitFindings: string
  indication: string
  summary: string
  providerSignatureDataUrl: string
  providerSignatureDate: string
}

export function createInitialProcedureReferralFormState(): ProcedureReferralFormState {
  return {
    recipient: null,
    specialtyCode: '',
    specialtyLabel: '',
    isEvaluationOnly: false,
    selectedCptCodes: [],
    diagnosisText: '',
    visitFindings: '',
    indication: '',
    summary: '',
    providerSignatureDataUrl: '',
    providerSignatureDate: '',
  }
}
